import { Button } from "antd";
import { MdOutlineSearch } from 'react-icons/md'

interface SubmitButtonProps {
  isSearch?: boolean;
  text: string;
  loading?: boolean
  onClick: () => void;
}

const SubmitButton = ({ text, isSearch, onClick, loading }: SubmitButtonProps) => {
  return (
    <Button
      style={{ marginTop: "1.5em" }}
      type="primary"
      htmlType="submit"
      size="large"
      icon={isSearch ? <MdOutlineSearch /> : null}
      className="loginButton"
      onClick={onClick}
      loading ={loading}
    >
      {text}
    </Button>
  );
};

export default SubmitButton;